import { Link } from 'react-router-dom';

export default function CtaBanner() {
  return (
    <section className="mx-auto w-full max-w-7xl px-4 pb-16 md:px-6 md:pb-20">
      <div className="relative overflow-hidden rounded-3xl">
        <img
          src="https://readdy.ai/api/search-image?query=soft%20dreamy%20pastel%20anime%20banner%20illustration%20of%20silhouetted%20small%20figures%20standing%20beneath%20a%20giant%20glowing%20heart%20in%20a%20starry%20sakura%20sky%2C%20warm%20golden%20and%20pink%20light%2C%20dreamy%20shoujo%20magical%20atmosphere%2C%20gentle%20warm%20color%20palette%2C%20cinematic%20composition%2C%20high%20detail&width=1400&height=500&seq=home-cta-01&orientation=landscape"
          alt="守护甜心主题爱心与星空的浪漫横幅插画"
          className="absolute inset-0 h-full w-full object-cover"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-900/70 via-primary-700/50 to-accent-600/40"></div>
        <div className="relative z-10 flex flex-col items-center gap-6 px-6 py-16 text-center md:flex-row md:justify-between md:px-12 md:text-left">
          <div className="max-w-xl">
            <h2 className="font-heading text-2xl font-black text-background-50 md:text-3xl">
              还没找到想看的角色？
            </h2>
            <p className="mt-3 text-sm leading-7 text-background-100 md:text-base">
              进入角色大全，按阵营筛选，查看每位角色的背景故事、守护甜心与幕后配音。资料一次集齐，随时对号入座。
            </p>
          </div>
          <div className="flex flex-col gap-3 sm:flex-row">
            <Link
              to="/characters"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full bg-background-50 px-7 py-3 text-sm font-semibold text-primary-700 transition-colors hover:bg-background-100"
            >
              <i className="ri-team-line" aria-hidden="true"></i>
              进入角色大全
            </Link>
            <Link
              to="/voice-actors"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-full border border-background-50/70 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/20"
            >
              <i className="ri-mic-line" aria-hidden="true"></i>
              查声优表
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}